import { render, staticRenderFns } from "./ClipboardCopy.vue?vue&type=template&id=e99fefbc&scoped=true"
import script from "./ClipboardCopy.vue?vue&type=script&lang=js"
export * from "./ClipboardCopy.vue?vue&type=script&lang=js"
import style0 from "./ClipboardCopy.vue?vue&type=style&index=0&id=e99fefbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99fefbc",
  null
  
)

export default component.exports